import { format } from 'date-fns';

/**
 * Anzeigestand des Fragenkatalog-Fallbacks (UCPWO-398).
 *
 * Kommt der Katalog aus dem Snapshot statt live von PX Connect, weist der Dialog darauf
 * hin und nennt den Stand. Der Zeitstempel ist dabei **Zusatzinformation**: fehlt er oder
 * ist er unlesbar, muss der Hinweis trotzdem erscheinen — nur eben ohne Datum. Ein
 * `Invalid Date` durch `format()` würde sonst den ganzen Dialog werfen, und das wäre
 * schlimmer als der Fehler, den der Fallback abfedern soll.
 */
export const snapshotDateLabel = (savedAt: string | undefined): string | undefined => {
    if (!savedAt) return undefined;
    const parsed = new Date(savedAt);
    return Number.isNaN(parsed.getTime()) ? undefined : format(parsed, 'dd.MM.yyyy');
};
